import React, {useContext, useState} from 'react';
import ContactIcon from '../../../assests/img/contact.svg?react';
import PhoneOutlineIcon from '../../../assests/img/phone-outline.svg?react';
import EmailIcon from '../../../assests/img/email.svg?react';
import FavouriteIcon from '../../../assests/img/favourite.svg?react';
import VisitingCard from '../../../assests/img/visting-card.png?url';
import Popup from './Popup';
import CardHeader from './CardHeader';
import InfoType from './InfoType';
import CardCoverageFacility from './CardCoverageFacility';
import CardDetailView from './CardDetailView';
import {updateField} from '../../Content';
import {FilterContext, favouriteType} from '../context/filterContext';
import {addFavourites} from '../api/postApi';
import {deleteDataApi} from '../api/deleteApi';
import {UserContext} from '../context/userContext';
import {filterData} from './DropdownFilter';
import {AuthContext} from '../context/authContext';
import '../../../assests/css/card.scss';

export interface cardType {
    id: number,
    name: string,
    logo: string,
    companyId: string,
    notes: string,
    submissionRequirements: string,
    uniqueRequirements: string,
    minimumCms: string,
    minimumTiv: string,
    distribution: string,
    type: string,
    groupId: number,
    coverage:
        {
            id: number,
            value: string,
            logo?: string
        },
    facilityTypes:
        {
            id: number,
            value: string,
        }[],
    contact: {
        id: number,
        name: string,
        phone: string,
        email: string,
        submissionEmail: string,
        title: string,
        address: string,
        department: string
    }[]
    categories: filterData[],
    showPopup: boolean,
    lastUpdated: string,
}

export interface cardProps {
    data: cardType,
    handleUpdate: (reqBody: any, field: updateField,
        endpoint?: string)=> Promise<number | void>,
    onWholesalersSelect: (select: boolean) => void,
    onGroupIdSelected: (id: number)=> void
}

export default function Card(props: cardProps) {
    const {data:{name, type, coverage, facilityTypes,
        contact, distribution, minimumTiv, logo, groupId,
        categories}, onWholesalersSelect} = props;
    
    const [showPopup, setShowPopup] = useState(props.data.showPopup);
    const [underwriterSelected, setUnderwriterSelected] = useState(false);
    const [loading, setLoading] = useState(false);
    const {filterData, setFilterData} = useContext(FilterContext);
    const {data: {userId}} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);
    const [updated, setUpdated] = useState('');

    const handlePopup = (popup: 'show' | 'hide')=> {
        setShowPopup(popup === 'show'? true: false);
        if (popup === 'hide') {
            if (updated.length) {
                props.onGroupIdSelected(0);
                props.handleUpdate({data: updated}, updateField.refreshData);
            }
        }
    }

    const onSelectedUnderwriter = (isSelected: boolean) =>
        setUnderwriterSelected(isSelected);
    
    const checkFavourite = () => {
        if (filterData.favourites && filterData.favourites.length) {
            const index = filterData.favourites.filter((data :any)=>
            data.companyGroupId === groupId);
            if (index.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const handleFavouriteIconClick = async (e: React.MouseEvent<HTMLDivElement,
        MouseEvent>) => {
        e.stopPropagation();
        setLoading(true);
        const favourite = checkFavourite();
        if (favourite && filterData.favourites) {
            const temp: favouriteType[] = [...filterData.favourites];
            const index = filterData.favourites.findIndex((data :any)=>
                data.companyGroupId === groupId);
            const favouriteId = filterData.favourites[index].id;
            const res = await deleteDataApi(`Favourites/id/${favouriteId}`,
                accounts);
            if (res === 204) {
                temp.splice(index, 1);
                setFilterData({...filterData, favourites: temp}, 'favorites');
            }
        } else {
            const addFavourite = {
                userId: userId,
                companyGroupId: groupId,
            }
            const res = await addFavourites(addFavourite, accounts);
            if (res.status === 201 && filterData.favourites) {
                const temp: any = [...filterData.favourites];
                temp.push(res.data.value[0]);
                setFilterData({...filterData, favourites: temp}, 'favorites');
            }
        }
        setLoading(false);
    }

    return (
        <>
        <Popup title=''
            show={showPopup}
            size='lg'  onClose={()=> handlePopup('hide')}
            backdrop={underwriterSelected? 'static': undefined}>
            <CardDetailView data={props.data} onClose={()=> handlePopup('hide')}
                handleUpdate={(reqBody: any, field: updateField,
                    endpoint?: string)=>
                    props.handleUpdate(reqBody, field, endpoint)}
                isUnderwriterSelected={(isSelected) =>
                    onSelectedUnderwriter(isSelected)}
                addNew={true} favourite={checkFavourite()}
                onWholesalersSelect={(selected) =>
                    onWholesalersSelect(selected)}
                updated={(input)=> setUpdated(`${updated}${input}`)}
                onGroupIdSelected = {(id) =>
                    props.onGroupIdSelected(id)}/>
        </Popup>
        <div className="card-container"
            onClick={()=> handlePopup('show')}
            >
            <div className="favourite-icon"
                onClick={(e)=> handleFavouriteIconClick(e)}>
                {loading? <span className="edit-loader"/>:
                    <FavouriteIcon width={13} height={18}
                    fill={checkFavourite()? 'rgba(255, 190, 93, 1)': '#fff'}
                    stroke={checkFavourite()? 'rgba(255, 190, 93, 1)': '#0058DD'}/>
                }
            </div>
            <CardHeader add={false}
                edit={false} onClose={()=> null}
                name={name} distribution={distribution}
                type={type} imgUrl={logo} view='brief'
                onWholesalerSelect={(selected)=>
                    onWholesalersSelect(selected)}
                onGroupIdSelected={()=> props.onGroupIdSelected(0)}
                categories={categories}
                groupId={0}/>
            <div className="card-seperator"></div>
            <div className="card-into-type">
                <InfoType type={distribution} showDropdown={false}
                    field='distribution'/>
                <InfoType type={type} showDropdown={false}
                    field='type'/>
            </div>
            <CardCoverageFacility edit={false}
                view='brief' coverage={coverage}
                facilityTypes={facilityTypes}/>
            <div className="card-minimum-tiv">   
                <span className="card-coverage-name">
                    {coverage.value.toLowerCase().trim() === 'property' ||
                        coverage.value.toLowerCase().trim() === 'pr'?
                        <span className='card-min-tiv'>
                            <span>$</span>
                            <span>Min TIV: {minimumTiv}</span>
                        </span>: null}
                </span>
            </div>
            <div className="card-contact-container">
                <div className="card-contact-name">
                    <ContactIcon width={"18"} height={"18"}/>
                    {contact[0]?.name ||  'No contact name provided'}
                </div>
                <div  className="card-contact-name">
                    <img className="card-title-img"
                        src={VisitingCard} alt='visting-card-img'
                        width={'18px'}/>
                    <div className="card-contact-name-type">{contact[0]?.title?
                        `${contact[0]?.title}${contact[0]?.department?
                            ', ' + contact[0]?.department: ''}`: ''}</div>
                </div>
                <div className="card-contact-details">
                    <div className="card-contact-phone">
                        <PhoneOutlineIcon width={"16"} height={"16"}/>
                        {contact[0]?.phone || 'No phone number provided'}
                    </div>
                    <div className="card-contact-phone">
                        <span> <EmailIcon width={"16"} height={"16"}/> </span>
                        <span className="card-brief-email">
                            {contact[0]?.submissionEmail || 'No Submission email address provided'}</span>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}